import React, { useState } from 'react';

export default function PdfExport()
{
    const [currentIndex, setCurrentIndex] = useState(0); // Initial selected item

    const yourItems = [
        { id: 1, name: 'Item 1' },
        { id: 2, name: 'Item 2' },
        { id: 3, name: 'Item 3' },
    ];

    function handleSelectItem(index)
    {
        setCurrentIndex(index);
    }

    return (
        <div>
            {yourItems.map((item, index) => (
                <button key={item.id}
                    isActive={index === currentIndex} 
                    style={{ backgroundColor: index === currentIndex ? 'lightblue' : 'white' }}
                    onClick={() => handleSelectItem(index)}>
                    {item.name}
                </button>
            ))}
        </div>
    );
}
